import Vue from 'vue'
import App from './App'
import router from './router'
import VueSession from 'vue-session'
import Unauth from './layouts/Unauth.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronUp, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import customAxios from 'axios'

// Add only the icons you need
library.add(faChevronDown, faChevronUp, faCheck, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Simple session options
const sessionOptions = {
  persist: true
}
Vue.use(VueSession, sessionOptions)

Vue.config.productionTip = false

// Initialize the app
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js